/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
    readonly action: PortfolioItemsAction;
    readonly endPortfolioItemId?: string | null;
    readonly itemsIds?: ReadonlyArray<string | null> | null;
    readonly note?: string | null;
    readonly portfolioItemsIds?: ReadonlyArray<string | null> | null;
    readonly portfolioId?: string | null;
    readonly portfolioType?: PortfolioType | null;
    readonly startPortfolioItemId?: string | null;
    readonly targetPortfolioItemId?: string | null;
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type addCartItemMutationVariables = {
    readonly input: ModifyPortfolioItemsInput;
};
export type addCartItemMutationResponse = {
    readonly modifyPortfolioItems: {
        readonly portfolio: {
            readonly items: {
                readonly totalResults: number | null;
            } | null;
        } | null;
    } | null;
};
export type addCartItemMutation = {
    readonly response: addCartItemMutationResponse;
    readonly variables: addCartItemMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "ModifyPortfolioItemsInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": null,
        "concreteType": "PortfolioItemsConnection",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalResults",
                "args": null,
                "storageKey": null
            }
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "addCartItemMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "modifyPortfolioItems",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ModifyPortfolioItemsPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "portfolio",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "addCartItemMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "modifyPortfolioItems",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ModifyPortfolioItemsPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "portfolio",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "id",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "addCartItemMutation",
            "id": "ferrum/229.0.0-2019-08-16T16:11:05.237Z/addCartItemMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '321aa184c3b379ab2a9f986679257e8d';
export default node;
